"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var __1 = require("../../..");
var __2 = require("../../../..");
var enums_1 = require("../../../../types/enums");
var energyOptions = [
    'virgin_loft_insulation',
    'loft_top_up',
    'cavity_wall_insulation',
    'external_wall_insulation',
    'underfloor_insulation',
    'ventilation',
    'double_glazing',
    'secondary_glazing',
    'draught_proofing',
    'replacement_door',
    'broken_repair',
    'heating_update',
    'first_time_central',
    'other',
];
var EnergyImprovementInput = function () {
    var _a, _b, _c, _d;
    var trans = __2.useSemantics().trans;
    var _e = formik_1.useFormikContext(), errors = _e.errors, values = _e.values;
    var energyImprovements = values.project.bget.energy_improvements;
    return (react_1.default.createElement(__1.FormControl, { errors: ((_b = (_a = errors.project) === null || _a === void 0 ? void 0 : _a.bget) === null || _b === void 0 ? void 0 : _b.energy_improvements) || [], label: trans('project:slhh::labels.energy-improvements'), showOther: energyImprovements && energyImprovements.indexOf(enums_1.BooleanOther.OTHER) > -1, other: react_1.default.createElement(__1.FormControl, { errors: (_d = (_c = errors.project) === null || _c === void 0 ? void 0 : _c.bget) === null || _d === void 0 ? void 0 : _d.energy_improvements_other, label: trans('project:slhh::labels.energy-improvements-other') },
            react_1.default.createElement(__1.TextArea, { name: "project.bget.energy_improvements_other", maxLength: 5000 })) },
        react_1.default.createElement("div", { className: "flex flex-col" }, energyOptions.map(function (key) { return (react_1.default.createElement(__1.Checkbox, { key: "energy_improvements." + key, name: "project.bget.energy_improvements", label: trans("project:slhh::enum.energy-improvements." + key), value: key })); }))));
};
exports.default = EnergyImprovementInput;
//# sourceMappingURL=EnergyImprovementInput.js.map